export const UPDATE_MEETING_STATUS_BEGIN = "UPDATE_MEETING_STATUS_BEGIN";
export const UPDATE_MEETING_STATUS_SUCCESS = "UPDATE_MEETING_STATUS_SUCCESS";
export const UPDATE_MEETING_STATUS_FAILURE = "UPDATE_MEETING_STATUS_FAILURE";
export const RESET_UPDATE_MEETING_STATUS = "RESET_UPDATE_MEETING_STATUS";
